"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const SvgNode_1 = __importDefault(require("../SvgNode"));
/**
 * Renders a debug view of the opening so we know what's going on.
 */
function DebugOpening({ opening }) {
    return (react_1.default.createElement("g", null,
        react_1.default.createElement(SvgNode_1.default, { nodeData: (0, __1.getLayerByPriority)(opening, ["print", "outer", "cut"]), style: {
                fill: "#FFFFFF",
            } }),
        react_1.default.createElement(SvgNode_1.default, { nodeData: opening.layout.cut, style: {
                stroke: "red",
                strokeWidth: 1,
                fill: "none",
            } }),
        react_1.default.createElement(SvgNode_1.default, { nodeData: opening.layout.inner, style: {
                stroke: "green",
                strokeWidth: 1,
                fill: "none",
            } }),
        react_1.default.createElement(SvgNode_1.default, { nodeData: opening.layout.print, style: {
                stroke: "blue",
                strokeWidth: 1,
                fill: "none",
            } }),
        react_1.default.createElement(SvgNode_1.default, { nodeData: opening.layout.outer, style: {
                stroke: "purple",
                strokeWidth: 1,
                fill: "none",
            } })));
}
exports.default = DebugOpening;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVidWdPcGVuaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZGVidWcvRGVidWdPcGVuaW5nLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLGtEQUEwQjtBQUMxQiwwQkFBd0M7QUFDeEMseURBQWlDO0FBTWpDOztHQUVHO0FBQ0gsU0FBd0IsWUFBWSxDQUFDLEVBQUUsT0FBTyxFQUFxQjtJQUNqRSxPQUFPLENBQ0w7UUFDRSw4QkFBQyxpQkFBTyxJQUNOLFFBQVEsRUFBRSxJQUFBLHNCQUFrQixFQUFDLE9BQU8sRUFBRSxDQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUUsS0FBSyxDQUFDLENBQUMsRUFDaEUsS0FBSyxFQUFFO2dCQUNMLElBQUksRUFBRSxTQUFTO2FBQ2hCLEdBQ0Q7UUFDRiw4QkFBQyxpQkFBTyxJQUNOLFFBQVEsRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLEdBQUcsRUFDNUIsS0FBSyxFQUFFO2dCQUNMLE1BQU0sRUFBRSxLQUFLO2dCQUNiLFdBQVcsRUFBRSxDQUFDO2dCQUNkLElBQUksRUFBRSxNQUFNO2FBQ2IsR0FDRDtRQUNGLDhCQUFDLGlCQUFPLElBQ04sUUFBUSxFQUFFLE9BQU8sQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUM5QixLQUFLLEVBQUU7Z0JBQ0wsTUFBTSxFQUFFLE9BQU87Z0JBQ2YsV0FBVyxFQUFFLENBQUM7Z0JBQ2QsSUFBSSxFQUFFLE1BQU07YUFDYixHQUNEO1FBQ0YsOEJBQUMsaUJBQU8sSUFDTixRQUFRLEVBQUUsT0FBTyxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQzlCLEtBQUssRUFBRTtnQkFDTCxNQUFNLEVBQUUsTUFBTTtnQkFDZCxXQUFXLEVBQUUsQ0FBQztnQkFDZCxJQUFJLEVBQUUsTUFBTTthQUNiLEdBQ0Q7UUFDRiw4QkFBQyxpQkFBTyxJQUNOLFFBQVEsRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssRUFDOUIsS0FBSyxFQUFFO2dCQUNMLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixXQUFXLEVBQUUsQ0FBQztnQkFDZCxJQUFJLEVBQUUsTUFBTTthQUNiLEdBQ0QsQ0FDQSxDQUNMLENBQUM7QUFDSixDQUFDO0FBM0NELCtCQTJDQyJ9